import axios from 'axios';
import AuthService from './auth-header';

let API_URL = ''
    if (process.env.NODE_ENV === "production") {
        API_URL = 'https://ats.sattvahuman.in/api/'
    } else {
        API_URL = 'http://192.168.0.30:5000/api/'
    }
// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ // const API_URL = 'https://ats.sattvahuman.in/api/';
class CalendarService {
    async addEvent(data) {
        console.log(data)
        try {
            const res = await axios.post(API_URL + 'events', data,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res.data)
            return res.data;
        }
        catch (err) {
            console.log(err.response)
            return err.response;
        }

    }

    async getAllEvents() {
        try {
            const res = await axios.get(API_URL + 'events',
                {
                    headers: AuthService.authHeader()
                });
            console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }

    async updateEvent(id, data) {
        //console.log(id)
        //console.log(AuthService.authHeader())
        try {
            const res = await axios.put(API_URL + 'events/' + id, data,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }


    async deleteEvent(id) {
        try {
            const res = await axios.delete(API_URL + 'events/' + id,
                {
                    headers: AuthService.authHeader()
                });
            console.log(res.data)
            return res.data
        }
        catch (err) {
            console.log(err.response)
            return err.response
        }
    }

}

export default new CalendarService();